import { useEffect } from 'react';
import { StreamEntityType } from 'types/enums';

export const useKeyboardEvents = ({
    id,
    ref,
    streamEntityType,
    playAnotherFragment,
    playFromBeginning,
    togglePlaying,
}: {
    id: string | undefined;
    ref?: React.RefObject<Element>;
    streamEntityType: StreamEntityType;
    playAnotherFragment: (interval: number) => void;
    playFromBeginning: () => void;
    togglePlaying: () => void;
}) => {
    const interval =
        streamEntityType === StreamEntityType.Samples ? 3000 : 7000;

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent): void => {
            if (
                e.repeat ||
                !ref?.current ||
                document.activeElement !== ref?.current
            ) {
                return;
            }

            switch (e.key) {
                case ' ':
                    e.preventDefault();
                    togglePlaying();
                    break;
                case 'Enter':
                    e.preventDefault();
                    playFromBeginning();
                    break;
                case 'ArrowRight':
                    e.preventDefault();
                    playAnotherFragment(interval);
                    break;
                case 'ArrowLeft':
                    e.preventDefault();
                    playAnotherFragment(interval * -1);
                    break;
                default:
                // Do nothing
            }
        };

        if (id) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return (): void => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        id,
        interval,
        ref,
        playAnotherFragment,
        playFromBeginning,
        togglePlaying,
    ]);
};

export default useKeyboardEvents;
